import { useApi, apiResolver } from "@/api/useApi";
import { useMemo } from "react";
import {
  GetCustomFieldKeysResponse,
  CustomField,
  GetCustomFieldValuesResponse,
} from "./CustomField.model";

type UpdateCustomFieldRequest = {
  customFieldExternalId: string;
  isActive: boolean;
  key: string;
};

export function useCustomFieldApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getCustomFieldKeys: () =>
        apiResolver<GetCustomFieldKeysResponse>(
          api.get(`/platform/custom-fields/keys`)
        ),
      getCustomFieldValues: () =>
        apiResolver<GetCustomFieldValuesResponse>(
          api.get(`/platform/custom-fields/values`)
        ),
      getTenantConversationCustomFieldValues: () =>
        apiResolver<GetCustomFieldValuesResponse>(
          api.get(`/platform/conversation-custom-fields/values`)
        ),
      // getTenantConversationCustomFieldValues: () =>
      //   apiResolver<GetCustomFieldValuesResponse>(
      //     api.get(`/platform/tenant-conversation-custom-fields/values`)
      //   ),
      updateCustomField: ({
        customFieldExternalId,
        isActive,
        key,
      }: UpdateCustomFieldRequest) =>
        apiResolver<CustomField>(
          api.put(`/platform/custom-fields/${customFieldExternalId}`, {
            isActive,
            key,
          })
        ),
    }),
    [api]
  );
}
